module.exports = __webpack_public_path__ + "static/media/slough.849703f0.jpg";